import store from '@/store'

export default {
  getHeaders() {
    if (!store.getters.token) {
      return {}
    }
    return {
      Authorization: `Token ${store.getters.token}`,
    }
  },
}
export function requireAuth(to, from, next) {
  if (!store.getters.isLoggedIn) {
    next({
      name: 'LoginPage',
      query: { redirect: to.fullPath },
    })
  } else {
    next()
  }
}

export function homepageRedirect(to, from, next) {
  if (!store.getters.isLoggedIn) {
    next({
      name: 'LoginPage',
    })
  } else {
    next({})
  }
}

export function noAuth(to, from, next) {
  if (store.getters.isLoggedIn) {
    next({
      name: 'DashboardPage',
    })
  } else {
    next({})
  }
}
